import React, { useState } from 'react';
import styles from './styles.module.css';

function PropertiesOwned({ record, onPropertyClick }) {
  // R33: Use propertiesOwnedHistory array if available, otherwise fallback to propertiesOwned
  const propertiesHistory = record?.propertiesOwnedHistory || [];
  const propertiesOld = record?.propertiesOwned || [];

  // Check if we have the new R33 structure (array of objects) or old structure (array of strings/keys)
  const hasNewStructure = propertiesHistory.length > 0 && typeof propertiesHistory[0] === 'object';

  // Use new structure if available, otherwise convert old structure to display format
  // Store original key for clicking
  const properties = hasNewStructure
    ? propertiesHistory.map(prop => ({ ...prop, propertyKey: prop.propertyKey }))
    : propertiesOld.map(key => ({ address: key, datePurchased: null, dateSold: null, propertyKey: key }));

  const [isExpanded, setIsExpanded] = useState(false);

  // Show first 5 properties by default
  const displayedProperties = isExpanded ? properties : properties.slice(0, 5);
  const hasMoreProperties = properties.length > 5;

  return (
    <section className={styles.containerPropertiesSection}>
      <span className={styles.propertiesTitle}>Properties owned</span>

      {properties.length === 0 ? (
        <div className={styles.noProperties}>N/A</div>
      ) : (
        <>
          <div className={styles.propertiesTable}>
            {/* Table Header */}
            <div className={styles.headerRow}>
              <span className={styles.header}>Property key</span>
              <span className={styles.header}>Date purchased</span>
              <span className={styles.header}>Date sold</span>
            </div>

            {/* Property Rows */}
            {displayedProperties.map((property, index) => {
              const hasPropertyKey = property.propertyKey;
              return (
                <div key={index} className={styles.propertyRow}>
                  <span className={styles.cell}>
                    {hasPropertyKey ? (
                      <span
                        className={styles.clickableText}
                        onClick={() => onPropertyClick(property.propertyKey)}
                      >
                        {property.propertyKey}
                      </span>
                    ) : (
                      'N/A'
                    )}
                  </span>
                  <span className={styles.cell}>
                    {property.datePurchased
                      ? new Intl.DateTimeFormat('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: '2-digit'
                        }).format(new Date(property.datePurchased))
                      : 'N/A'}
                  </span>
                  <span className={styles.cell}>
                    {property.dateSold
                      ? new Intl.DateTimeFormat('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: '2-digit'
                        }).format(new Date(property.dateSold))
                      : 'Not sold'}
                  </span>
                </div>
              );
            })}
          </div>

          {hasMoreProperties && (
            <button
              className={styles.expandButton}
              onClick={() => setIsExpanded(!isExpanded)}
            >
              {isExpanded ? 'Show less' : `Expand All (${properties.length})`}
            </button>
          )}
        </>
      )}
    </section>
  );
}

export default PropertiesOwned;
